<div id="sort-filter-form">
  <!-- Sort Order -->
  <mat-form-field id="sort-order-select">
    <mat-label>Sort By:</mat-label>
    <mat-select name="sortBy" [value]="filterSet().sortBy" (selectionChange)="onSortSelectChange($event)">
      @if(filterSet().seriesFilter!.substring(0,3) != '-- '){
      <mat-option value="seriesReadingOrder">Series Reading Order</mat-option>
      }
      <mat-option value="title">Title</mat-option>
      <mat-option value="recentlyAdded">Recently Added</mat-option>
      <mat-option value="author">Primary Author</mat-option>
      <mat-option value="titleWithout">Title (w/o 'The', 'A')</mat-option>
    </mat-select>
  </mat-form-field>
  <!--  Title Search Term  -->
  <div class="form-field-div">
    <mat-form-field>
      <input matInput placeholder="Search title for:" #titleSearchTxt type="text" [value]="filterSet().titleSearchTerm"
        (change)="onTextFieldChange($event, 'titleSearchTerm')"
        (keyup)="onTextFieldChange($event, 'titleSearchTerm')" />
    </mat-form-field>
  </div>
  <!-- Title Starts with Search Term  Checkbox -->
  <div class="form-field-div">
    <mat-checkbox name="startsWithFlag" #startsWithFlag [checked]="filterSet().startsWithFlag"
      (change)="onCheckBoxChange($event, 'startsWithFlag')">Title Must Start
      with Search Term
    </mat-checkbox>
  </div>
  <!-- Book Type -->
  <div class="form-field-div">
    <mat-form-field id="type-select">
      <mat-label>Type: </mat-label>
      <mat-select name="typeSelect" [value]="filterSet().typeSelect"
        (selectionChange)="onSelectChange($event, 'typeSelect')">
        @for (type of typeOptions; track type) {
        <mat-option [value]="type">
          {{ type }}
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>
  <!-- Select A Series Picklist -->
  <mat-form-field id="series-select">
    <mat-label>Filter Series</mat-label>
    <mat-select name="seriesFilter" [value]="filterSet().seriesFilter"
      (selectionChange)="onSelectChange($event, 'seriesFilter')">
      @for( s of seriesOptions; track s) {
      <mat-option [value]="s.seriesName">
        {{ s.seriesName }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <!-- Select An Author Picklist -->
  <mat-form-field id="author-select">
    <mat-label>Filter Author</mat-label>
    <mat-select name="authorFilter" [value]="filterSet().authorFilter"
      (selectionChange)="onSelectChange($event, 'authorFilter')">
      @for( a of authorOptions; track a) {
      <mat-option [value]="a.author">
        {{ a.author }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <!-- Select A Narrator Picklist -->
  <mat-form-field id="narrator">
    <mat-label>Filter Narrator</mat-label>
    <mat-select name="narratorFilter" [value]="filterSet().narratorFilter"
      (selectionChange)="onSelectChange($event, 'narratorFilter')">
      @for( n of narratorOptions; track n) {
      <mat-option [value]="n.narrator">
        {{n.narrator }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  <!-- If Logged In Checkboxes -->
  @if(isLoggedIn()) {
  <div *ngIf="isLoggedIn()">
    <hr>
    <mat-checkbox name="addedByMeCheck" [checked]="filterSet().addedByMe"
      (change)="onCheckBoxChange($event, 'addedByMe')">Added By
      Me
    </mat-checkbox>
    <br />
    <mat-checkbox name="notReadByMe" [checked]="filterSet().notReadByMe"
      (change)="onCheckBoxChange($event, 'notReadByMe')">I Have
      NOT Read</mat-checkbox>
    <br />
    <mat-checkbox name="imInterestedIn" [checked]="filterSet().imInterestedIn"
      (change)="onCheckBoxChange($event, 'imInterestedIn')">I'm
      Interested In</mat-checkbox>
    <br />
    <mat-checkbox name="recommendedForMe" [checked]="filterSet().recommendedForMe"
      (change)="onCheckBoxChange($event, 'recommendedForMe')">Recommended For Me</mat-checkbox>
    <br />
    <mat-checkbox name="recommendedByMe" [checked]="filterSet().recommendedByMe"
      (change)="onCheckBoxChange($event, 'recommendedByMe')">Recommended By Me</mat-checkbox>
    <br />
    <mat-checkbox name="readByMe" [checked]="filterSet().haveRead" (change)="onCheckBoxChange($event, 'haveRead')">I
      Have
      Read</mat-checkbox>
    <mat-checkbox name="notAddedByMeCheck" [checked]="filterSet().notAddedByMe"
      (change)="onCheckBoxChange($event, 'notAddedByMe')">Not Added By
      Me
    </mat-checkbox>
    <br />
    <hr>
  </div>
  }
  <!-- Clear Filters Button -->
  <button mat-raised-button color="accent" name="clearFilters" (click)="clearFilters()">Clear Filters</button>
  <!--
  <div>
    <textarea style=" width: 100%; height: 30em ;">{{ getDiagnostic() | json }}</textarea>
  </div>
-->
</div>